import React from 'react';
import "./App.scss"
import { BrowserRouter as Router, Route, Switch} from 'react-router-dom'
import S2txtMainFile from './components/speech2text/S2txtMainFile';
import AdminMainFile from './components/admin/AdminMainFile';
import Auth from './components/auth/Auth';
// import S2tranMainFile from './components/speech2translate/S2tranMainFile';

// v

const App = () => {

    return ( 
       <Router>
           <Switch>
               <Route path='/stream/:id?' component={S2txtMainFile} />
               <Route path='/lvcconnectreact/admin' component={AdminMainFile} />
               <Route path='/' exact component={Auth} />
           </Switch>
       </Router>
    )
}

export default App